<template>
  <div
    v-if="show"
    class="alert-banner text-center"
  >
    <slot />

    <div
      class="alert-banner__close stick-right"
      @click="closeBanner"
    >
      <button
        class="vs-btn-legacy btn-close md-close"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    closeHandler: {
      type: Function,
      default: undefined,
    },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    closeBanner() {
      if (typeof this.closeHandler === 'function') {
        const result = this.closeHandler();
        if (typeof result === 'boolean') {
          this.show = result;
        }
      } else {
        this.show = false;
      }
    },
  },
};
</script>

<style>
.alert-banner {
  padding: 1em 60px;
  background: #e9e9e9;
  position: relative;
}

.alert-banner__close {
  top: 10px;
  opacity: 0.5;
}
</style>
